<template>
  <div class="app__content section">
    <div class="section__wrapper">
      <div class="section__content">
        <h2 class="">{{ resetTitle }}</h2>
        <form v-if="$route.query.token && !passwordResetSuccess" class="form" @submit.prevent="submitPassword()">
          <div class="form__group">
            <p>Choose a new password</p>
            <div class="form__input-group form__input-group--full form__input-group--wrap">
              <label class="form__label--hidden" for="password">New password</label>
              <input
                :class="{ 'form__input--error': $v.auth.password.$error }"
                v-model="auth.password"
                @input="handleFieldInput('password')"
                class="form__input" name="password" type="password"
                placeholder="Password"
              >

              <label class="form__label--hidden" for="passwordConfirm">Confirm password</label>
              <input
                :class="{ 'form__input--error': $v.auth.password.$error }"
                v-model="auth.passwordConfirm"
                @input="handleFieldInput('passwordConfirm')"
                class="form__input" name="passwordConfirm" type="password"
                placeholder="Confirm password"
              >

              <span
                v-if="$v.auth.password.$error || $v.auth.passwordConfirm.$error"
                class="form__help form__help--error"
              >
                Your password must be 8 or more characters. Password confirmation must match password.
              </span>
            </div>
              <button type="submit" class="button form__submit">
                  Submit
              </button>

              <p class="form__link mr-2" v-if="authMessage">{{ authMessage }}</p>
          </div>
        </form>
        <form v-else-if="!passwordResetSuccess" class="form" @submit.prevent="submitEmail()">
          <div class="form__group">
            <p>Enter your email and we'll send you a link to reset your password</p>
            <div class="form__input-group form__input-group--full form__input-group--wrap">
              <label class="form__label--hidden" for="email">Email</label>
              <input :class="{ 'form__input--error': authError }" class="form__input" name="email" type="email" v-model="auth.email" placeholder="Email">

              <button type="submit" class="button form__submit">
                  Send
              </button>

              <p class="form__link mr-2" v-if="authMessage">{{ authMessage }}</p>

            </div>
          </div>
        </form>
        <router-link class="form__link mr-2" :to="{ name: 'view-login' }">Login</router-link>
        <router-link class="form__link" :to="{ name: 'view-register' }">Register</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { PasswordReset, PasswordResetTwo } from '../services/api';

const touchMap = new WeakMap();

export default {
  name: 'password-reset',
  data() {
    return {
      auth: {
        email: '',
        password: '',
        passwordConfirm: '',
      },
      authError: false,
      authMessage: false,
      passwordResetSuccess: false,
    };
  },
  validations: {
    auth: {
      password: { required, minLength: minLength(8) },
      passwordConfirm: { required, sameAsPassword: sameAs('password') },
    },
  },
  computed: {
    resetTitle() {
      if (this.passwordResetSuccess) {
        return 'Your password has been updated, please use the link below to login';
      } else if (this.$route.query.token) {
        return 'Enter a new password';
      }
      return 'Requested a password change?';
    },
  },
  methods: {
    handleFieldInput(field) {
      if (this.auth[field]) {
        this.$v.auth[field].$reset();
        if (touchMap.has(this.$v.auth[field])) {
          clearTimeout(touchMap.get(this.$v.auth[field]));
        }
        touchMap.set(this.$v.auth[field], setTimeout(this.$v.auth[field].$touch, 1000));
      }
    },
    submitEmail() {
      PasswordReset({ email: this.auth.email }).then((res) => {
        if (res.ok) {
          this.authMessage = 'Thanks, we\'ve sent you an email with a link to reset your password.';
        } else {
          this.authMessage = 'Sorry, something went wrong';
        }
      })
      .catch(() => {
        this.authMessage = 'Sorry, something went wrong';
      });
    },
    submitPassword() {
      this.$v.auth.password.$touch();
      this.$v.auth.passwordConfirm.$touch();

      if (this.$v.auth.password.$error || this.$v.auth.passwordConfirm.$error) return;

      PasswordResetTwo({ token: this.$route.query.token, password: this.auth.password })
      .then((res) => {
        if (res.ok) {
          this.authMessage = 'Thanks, your password has been successfully updated.';
          this.passwordResetSuccess = true;
        } else {
          this.authMessage = 'Sorry, something went wrong';
        }
      })
      .catch(() => {
        this.authMessage = 'Sorry, something went wrong';
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// password-reset.vue?75c7ad50